import Message from 'shared_components/message';
import { axiosLabAPI } from 'services/axios';
import { API_GET_METHOD, API_POST_METHOD, API_PUT_METHOD } from 'global_config/constant-global';
import { showMessage } from 'services/settings/message';

export async function fetchAgeBracketList() {
	let ageBrackList = null;

	try{
		const content = {
			method: API_GET_METHOD,
			url: `settings/agebracket`
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;

		// Handle new API response format
		if (data && data.STATUSCODE === 200 && data.RECORDS) {
			ageBrackList = data.RECORDS;
		} 
	}
	catch(e) {
		showMessage(e);
	}

	return ageBrackList;
}


export async function createAgeBracket(payload) {
	let createdAgeBracket;

	try{
		const content = {
			method: API_POST_METHOD,
			url: 'settings/agebracket',
			data: payload
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;

		// Handle new API response format
		if (data && data.STATUSCODE === 200 && data.RECORDS) {
			createdAgeBracket = data.RECORDS;
		} else {
			createdAgeBracket = data;
		}
	}
	catch(e) {
		showMessage(e);
	}

	return createdAgeBracket;
}

export async function updateAgeBracket(payload) {
	let createdAgeBracket;

	try{
		const content = {
			method: API_PUT_METHOD,
			url: 'settings/agebracket',
			data: payload
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;

		// Handle new API response format
		if (data && data.STATUSCODE === 200 && data.RECORDS) {
			createdAgeBracket = data.RECORDS;
		}
	}
	catch(e) {
		showMessage(e);
	}

	return createdAgeBracket;
}

export async function applySorting(dataPayload) {
	let result = null;

	try {
		const content = {
			method: API_PUT_METHOD,
			url: 'settings/agebracketsorting',
			data: {
				p_age_bracket_sorting_array: JSON.stringify(dataPayload),
			},
		};

		const response = await axiosLabAPI(content);
		const { data } = await response;

		if (data && data.STATUSCODE === 200) {
			result = data;
		}
	} catch (e) {
		showMessage(e);
	}

	return result;
}
